import React from 'react'
import { Link } from 'react-router-dom'
import Style from '../updates.module.css'
import { CONNECTION_STATUS, needsSetup, summarizeConnections } from '../../../../features/connections/connectionStatus'
import { PATH, paths } from '../../../../app/routes'

const setupLink = (connections) => {
    const pending = connections.filter(needsSetup)
    if (pending.length !== 1) {
        return PATH.MY_PRODUCTS
    }
    const [connection] = pending
    return paths.setup(connection.id, connection.instances[0].id)
}

const Stat = ({ to, tone, icon, value, label, needsAttention }) => (
    <Link
        to={to}
        className={[Style.stat, Style[`tone_${tone}`], needsAttention ? Style.attention : ''].join(' ')}
        aria-label={`${value} ${label}`}
    >
        <span className={Style.statIcon}><i className={icon} aria-hidden="true" /></span>
        <span className={Style.statBody}>
            <span className={Style.statValue}>{value}</span>
            <span className={Style.statLabel}>{label}</span>
        </span>
    </Link>
)

const AtAGlance = ({ connections }) => {
    const summary = summarizeConnections(connections)

    return (
        <section className={Style.section} aria-labelledby="glance-title">
            <div className={Style.sectionHeader}>
                <div>
                    <h2 id="glance-title" className={Style.sectionTitle}>Your connectors at a glance</h2>
                    <p className={Style.sectionHint}>
                        {summary.total} connector{summary.total === 1 ? '' : 's'} in your account
                    </p>
                </div>
                <Link to={PATH.MY_PRODUCTS} className={Style.sectionLink}>
                    Go to My Products <i className="uil-angle-right" aria-hidden="true" />
                </Link>
            </div>
            <div className={Style.stats}>
                <Stat
                    to={paths.myProducts({ status: CONNECTION_STATUS.ACTIVE })}
                    tone="success"
                    icon="uil-check-circle"
                    value={summary.active}
                    label="Active"
                />
                <Stat
                    to={paths.myProducts({ status: CONNECTION_STATUS.EXPIRING })}
                    tone="warning"
                    icon="uil-clock"
                    value={summary.expiring}
                    label="Expiring within 30 days"
                    needsAttention={summary.expiring > 0}
                />
                <Stat
                    to={paths.myProducts({ status: CONNECTION_STATUS.EXPIRED })}
                    tone={summary.expired > 0 ? 'danger' : 'neutral'}
                    icon="uil-exclamation-circle"
                    value={summary.expired}
                    label="Expired"
                    needsAttention={summary.expired > 0}
                />
                <Stat
                    to={setupLink(connections)}
                    tone={summary.needsSetup > 0 ? 'info' : 'neutral'}
                    icon="uil-wrench"
                    value={summary.needsSetup}
                    label="Waiting for setup"
                />
            </div>
        </section>
    )
}

export default AtAGlance
